import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Select } from '@resurs/midas-react'
import { getText } from '../../../../internal/TextLabels'

const MOMENT_PERIODS = {
  YEAR: {
    duration: 'years',
    timeUnit: 'year',
    numberOfPeriods: 2,
    format: 'YYYY',
  },
  MONTH: {
    duration: 'months',
    timeUnit: 'month',
    numberOfPeriods: 13,
    format: 'MMM YYYY',
  },
  WEEK: {
    duration: 'weeks',
    timeUnit: 'isoweek',
    numberOfPeriods: 54,
    format: '[v.]W YYYY',
  },
}

const PERIOD_LABELS = {
  YEAR: 'statistics.selectTimespan.year',
  MONTH: 'statistics.selectTimespan.month',
  WEEK: 'statistics.selectTimespan.week',
}

const ISO_DATE_FORMAT = 'YYYY-MM-DD'

function* getPeriods(period, language) {
  if (!MOMENT_PERIODS[period]) {
    return
  }
  const options = MOMENT_PERIODS[period]
  const next = moment().clone().locale(language)
  let count = 0
  yield next.clone()
  // eslint-disable-next-line no-plusplus
  while (++count < options.numberOfPeriods) {
    yield next.subtract(1, options.duration).endOf(options.timeUnit).clone()
  }
}

const PeriodSelector = ({
  selectedPeriod,
  selectDate,
  selectedDate,
  language,
}) => (
  <Select
    id="period-dates"
    size="large"
    label={getText(PERIOD_LABELS[selectedPeriod])}
    value={selectedDate}
    values={[...getPeriods(selectedPeriod, language)].map(m => ({
      key: m.format(ISO_DATE_FORMAT),
      value: m.format(ISO_DATE_FORMAT),
      valueLabel: m.format(MOMENT_PERIODS[selectedPeriod].format),
    }))}
    onChange={value => selectDate(value)}
  />
)

PeriodSelector.propTypes = {
  selectDate: PropTypes.func.isRequired,
  selectedDate: PropTypes.string.isRequired,
  selectedPeriod: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
}

export default PeriodSelector
